import { CheckCircleOutline, CompressOutlined, ConstructionOutlined, ContactsOutlined, ContentCutOutlined, PanoramaFishEye } from "@mui/icons-material";
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useEffect, useState } from "react";

import myFunctions from "../../../myFunctions";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import TheMoreThenOneMount from "../../../OrderSettings/TheMoreThenOneMount";
import SplitForPizza from "./SplitForPizza";

const OrderChkSel = (props) => {

    const [theItem] = useState(props.itm);
    const [theLstDisp, setTheLstDisp] = useState(props.indx);
    const [dispPrices, setDispPrices] = useState(false);

    // const [cheksBack, setCheksBack] = useState(theItem.selected != "" ? theItem.selected : []);

    let tempChks = (theItem.selected && Array.isArray(theItem.selected) && theItem.selected.length > 0)
        ? theItem.selected.map(item => ({ ...item }))
        : [];

    let selectedCounting = 0;


    useEffect(() => {
        hideTheNotInStock();
        getOpts(theItem.selected)
        selectedCounting = myFunctions.getTotalSelected(theItem.selected);
    }, [])

    const hideTheNotInStock = () => {
        for (let indx = theItem.options.length - 1; indx >= 0; indx--) {
            const element = theItem.options[indx];

            if (element.inStock != null && element.inStock === false) {
                theItem.options.splice(indx, 1);
            }
        }
    }

    const setThelst = (tempoChks) => {
        getOpts(tempoChks);
        props.ContCallBack(tempoChks)

    }


    const SplitForPizzaFunc = (item, splt) => {


        let checkerSplit = splt;

        //מחפש את מיקום הצ'ק בוקס ברשימת הצ'ק בוקסים
        let curChk = tempChks.findIndex(it => it.servType == item.servType);

        tempChks[curChk].splitSelected = splt;

        tempChks = OrderFunctions.getPizzaPriceAfterFree(tempChks, theItem)

        setThelst(tempChks)


    }

    // //מסמן צ'ק בוקס חובה כי אין משהו שנבחר
    // const updateChkByDefault = (item, fixedPrice) => {


    //     let itmToPush = { ...item }
    //     if (itmToPush.splitSelected == null) {
    //         itmToPush.splitSelected = "full";
    //     }
    //     fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
    //     itmToPush.addToPrice = fixedPrice;

    //     tempChks.push(itmToPush);


    //     getOpts(tempChks);

    //     // setCheksBack(tempChks);

    //     props.ContCallBack(tempChks)
    // };

    // let splits = 0;

    const updatePizzaChkSelection = (item, fixedPrice, chkVal, setByMustSelect) => {

        let curChk = tempChks.findIndex(it => it.servType == item.servType);

        if (curChk != -1) {
            if (chkVal == false) {
                tempChks.splice(curChk, 1);
            }
        }
        else {
            let itmToPush = { ...item }
            if (itmToPush.splitSelected == null) {
                itmToPush.splitSelected = "full";
            }
            fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
            itmToPush.addToPrice = fixedPrice;
            itmToPush.itmsMount = 1;

            tempChks.push(itmToPush);

        }
        selectedCounting = myFunctions.getTotalSelected(tempChks);

        setThelst(tempChks)
    }

    const updateChkSelection = (item, fixedPrice, chkVal, setByMustSelect) => {

        if (setByMustSelect) {

            let itmToPush = { ...item }
            if (itmToPush.splitSelected == null) {
                itmToPush.splitSelected = "full";
            }
            fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
            itmToPush.addToPrice = fixedPrice;

            tempChks.push(itmToPush);
        }
        else {
            let curChk = tempChks.findIndex(it => it.servType == item.servType);
            if (curChk != -1) {
                if (chkVal == false) {
                    tempChks.splice(curChk, 1);
                }
            }
            else {
                let itmToPush = { ...item }
                if (itmToPush.splitSelected == null) {
                    itmToPush.splitSelected = "full";
                }
                fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
                itmToPush.addToPrice = fixedPrice;
                itmToPush.sourcePrice = theItem.options.find((it, index) => it.servType == itmToPush.servType).addToPrice
                itmToPush.itmsMount = 1;

                tempChks.push(itmToPush);
            }
        }

        //מעדכן כמה פריטים נבחרו עד כה ברשימה המתקבלת
        selectedCounting = myFunctions.getTotalSelected(tempChks);

        setThelst(tempChks)

    };

    const updateRdbSelection = (item, fixedPrice, chkVal, setByMustSelect) => {



        if (setByMustSelect) {
            let itmToPush = { ...item }
            itmToPush.splitSelected = "full";

            fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
            itmToPush.addToPrice = fixedPrice;
            itmToPush.itmsMount = 1;

            tempChks.push(itmToPush);
        }
        else {

            tempChks = [];

            let itmToPush = { ...item }
            if (itmToPush.splitSelected == null) {
                itmToPush.splitSelected = "full";
            }

            fixedPrice = (fixedPrice != "NaN") ? fixedPrice : 0;
            itmToPush.addToPrice = fixedPrice;
            itmToPush.itmsMount = 1;

            tempChks.push(itmToPush);
        }

        setThelst(tempChks)

    };


    const updatMount = (item, newVal) => {

        let itmToPush = { ...item }

        let foundIt = tempChks.findIndex(itm => itm.servType == itmToPush.servType);
        if (foundIt != -1) {

            if (isNaN(tempChks[foundIt].addToPrice)) {
                tempChks[foundIt].addToPrice = itmToPush.addToPrice;
            }

            tempChks[foundIt].itmsMount = newVal

            // tempChks[foundIt].addToPrice = (parseFloat(tempChks[foundIt].itmsMount) * parseFloat(tempChks[foundIt].sourcePrice)).toString();
            // tempChks[foundIt].addToPrice = !isNaN(tempChks[foundIt].addToPrice) ? (parseFloat(tempChks[foundIt].sourcePrice)) : 0;
            // tempChks[foundIt].addToPrice = (tempChks[foundIt].addToPrice != "NaN") ? tempChks[foundIt].addToPrice : 0;
        }

        selectedCounting = myFunctions.getTotalSelected(tempChks);

        setThelst(tempChks)

    }

    const clearchkBx = (item, priceAfterFix) => {
        updateChkSelection(item, priceAfterFix)
    }

    // ***************   MAIN     *****************  
    const getOpts = (theLst) => {

        let theSplits = theItem.splitSelection ? true : false;
        let spSelQurts = (theItem.splitSelection && theItem.spSelQurts);

        let Allselected = 0;

        let setByMustSelect = false;

        let inTheloop = false;
        // ❌ הסרנו את הבחירה האוטומטית של האלמנט הראשון
        // if (theItem.mustSelect && (!theLst || theLst.length == null)) {
        //     if (theItem.options.length > 0) {
        //         ...
        //     }
        // }

        if (!inTheloop) {
            let fullsSelc = 0;

            let opts = theItem.options.map((item, index) => {

                setByMustSelect = (index == 0) ? setByMustSelect : false;
                let chkd = false;

                let checkerSplit = null;

                let showfullPCss = true;
                let showHalfs = true;

                let itemsMount = 1;

                let disabledOr = false;
                if (theItem.maxSelection == 0) {
                    disabledOr = false
                }
                else {
                    if (theItem.maxSelection <= myFunctions.getTotalSelected(theLst) || setByMustSelect) {
                        disabledOr = true;
                    }

                }

                let priceAfterFix = item.addToPrice;

                if (theLst) {
                    for (let i = 0; i < theLst.length; i++) {

                        if (theLst[i].servType == item.servType) {
                            chkd = true;
                            disabledOr = false;

                            itemsMount = theLst[i].itmsMount;

                            fullsSelc = parseFloat(fullsSelc) + (itemsMount * 2);

                            if (theLst[i].splitSelected !== "full") {
                                checkerSplit = theLst[i].splitSelected;
                            }

                        }

                    }
                }
                //תוספות נלווים בחינם
                if (chkd) {
                    // לא לחלוקת פיצה

                    if (!theSplits) {
                        priceAfterFix = OrderFunctions.getPriceAfterFree(theItem.freeAdds, fullsSelc, priceAfterFix)
                    }
                    // רק פיצה
                    else {

                        priceAfterFix = theLst.find(itm => itm.servType == item.servType).addToPrice
                    }
                }


                let thisRoundChkBox = "";

                ///במידה ומוגדר בחירה חובה
                if (theItem.mustSelect) {

                    // ❌ הסרנו את הבחירה האוטומטית
                    // if (theLst.length == 0 && index == 0) {
                    //     updateRdbSelection(item, priceAfterFix, true, true)
                    //     chkd = true;
                    // }

                    ///במידה ומוגדר בחירה חובה ומרובה
                    if (theItem.chkMoreThenOne || theItem.maxSelection > 1) {
                        thisRoundChkBox =
                            <Checkbox
                                // value={soundCheckd}
                                checked={chkd}
                                onChange={() => updateChkSelection(item, priceAfterFix, !chkd)}
                                checkedIcon={<CheckCircleOutline />}
                                icon={<PanoramaFishEye />}
                                sx={{}}
                            />

                        // <Checkbox checked={chkd}
                        //     // sx={{ color: "var(--turqiText)" }}
                        //     onChange={() => updateChkSelection(item, priceAfterFix, !chkd)}
                        // />
                    }
                    else {
                        thisRoundChkBox =
                            <Checkbox
                                checked={chkd}
                                onChange={() => updateChkSelection(item, priceAfterFix, !chkd)}
                                checkedIcon={<CheckCircleOutline />}
                                icon={<PanoramaFishEye />}
                            />
                    }
                }
                else {
                    if (theSplits) {
                        thisRoundChkBox =
                            <Checkbox
                                // value={soundCheckd}
                                checked={chkd}
                                onChange={() => updatePizzaChkSelection(item, priceAfterFix, !chkd)}
                                checkedIcon={<CheckCircleOutline />}
                                icon={<PanoramaFishEye />}
                                sx={{}}
                            />

                    }
                    else {

                        thisRoundChkBox =
                            <Checkbox
                                // value={soundCheckd}
                                checked={chkd}
                                onChange={() => updateChkSelection(item, priceAfterFix, !chkd)}
                                checkedIcon={<CheckCircleOutline />}
                                icon={<PanoramaFishEye />}
                                sx={{}}
                            />

                        // <Checkbox checked={chkd}
                        //     // sx={{ color: "var(--turqiText)" }}
                        //     onChange={() => updateChkSelection(item, priceAfterFix, !chkd)}
                        // />

                    }
                }


                return (
                    <div key={index} className={`selectionChk ${theItem.chkSideBySide ? "sideBySide" : ""} `}>

                        <FormControlLabel control={
                            thisRoundChkBox
                        }
                            sx={{ fontFamily: "var(--SecondFont)" }}
                            className={"FirstFont"}
                            label={item.servType}
                            disabled={disabledOr}
                        />

                        <div className={"changePrice"} id={`prID_${index}`}>
                            {(priceAfterFix != 0) ? `${priceAfterFix} ₪ +` : ``}
                        </div>
                        {(theSplits && chkd) ?
                            <div className={`pizzaSplt ${(priceAfterFix != null && priceAfterFix > 0) ? "" : " splitSelectorSpacNoPrice"} onLeft`} >
                                <SplitForPizza checkerSplit={(checkerSplit != null) ? checkerSplit : "full"}
                                    showHalfs={showHalfs} showfullPCss={showfullPCss} showQurters={spSelQurts}
                                    pizzaSplit={(splt) => SplitForPizzaFunc(item, splt, `prID_${index}`)}
                                />
                            </div>
                            : ""}
                        {theItem.chkMoreThenOne && chkd ?
                            <div id={`M_` + index} className={`ordItmLine TheMoreThenOneMount ${theItem.chkSideBySide ? "small" : ""}`}>
                                <span className={"itemMountLf "}>
                                    <TheMoreThenOneMount key={`MTO_${index} `} css={"prodPlusMinus "}
                                        Mount={itemsMount}
                                        minCount={1}
                                        maxSelection={theItem.maxSelection}
                                        selectedCounting={selectedCounting}
                                        itemId={item.id}
                                        clearchkBx={() => clearchkBx(item, priceAfterFix)}
                                        remFromOrder={(bak) => { item.mount = bak }}
                                        changeVal={(newVal) => { updatMount(item, newVal) }}
                                    />
                                </span>
                            </div> : ""}


                    </div>
                )
            })

            setTheLstDisp(opts)

        }




    }


    const getSplit = (spltSelect) => {
        let steper = 0;
        switch (spltSelect) {
            case "full":
                {
                    steper = 1;
                    break;
                }
            case "lHalf":
                {
                    steper = 0.5;
                    break;
                }
            case "rHalf":
                {
                    steper = 0.5;
                    break;
                }
            case "rtQuart" ||
                "rbQuart" ||
                "ltQuart" ||
                "lbQuart":
                {
                    steper = 0.5;
                    break;
                }

            default:
                {
                    steper = 0;
                    break;
                }
        }

        return steper
    }

    return (
        <fieldset className="prodSelect" data-option-index={props.indx}>
            <legend className="optSelHeads">
                {theItem.optionName}
                {theItem.mustSelect && (
                    <span style={{ color: '#f44336', marginRight: '5px', fontSize: '14px' }}> *</span>
                )}
                {theItem.mustSelect && (!theItem.selected || theItem.selected.length === 0) && (
                    <span style={{
                        color: '#f44336',
                        marginRight: '10px',
                        fontSize: '13px',
                        fontWeight: 'normal'
                    }}>
                        - בחירה חובה
                    </span>
                )}
            </legend>
            <div>
                {theLstDisp}
            </div>

        </fieldset>
    )
}

export default OrderChkSel;
